import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'app-classroom-navbar',
	standalone: true,
	imports: [MatButtonModule, MatMenuModule, MatIconModule, RouterModule],
	templateUrl: './classroom-navbar.component.html',
	styleUrl: './classroom-navbar.component.scss'
})
export class ClassroomNavbarComponent {

}
